module.exports = __webpack_public_path__ + "static/Riley-105-a936a68f6dc779ffcf1902f18599f19e.jpg";